import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const LAUNCH_DATE = new Date("2026-09-15T09:00:00");
export const EARLY_BIRD_DATE = new Date("2026-09-08T23:59:59");
